import application from 'application/application';

application

	.directive('ngInnerHtml', () => ({
		restrict: 'A',
		scope: {
			ngInnerHtml: '='
		},
		link(scope, element) {

			element.html(scope.ngInnerHtml);

		}
	}));
